// Import model
import { CreateContactTaskRequest } from '../models/CreateContactTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateContactTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateContactTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateContactTaskRequest instance
   */
  static deserialize(json: string): CreateContactTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateContactTaskRequest instance
   */
  static fromObject(obj: any): CreateContactTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateContactTaskRequest');
    }


    const instance: CreateContactTaskRequest = {
      parentObjectId: obj['parentObjectId'] as string,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string,
      assignedUserId: obj['assignedUserId'] as string | undefined,
      dueDate: obj['dueDate'] as string | undefined,
      priority: obj['priority'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateContactTaskRequest instances
   */
  static deserializeArray(json: string): CreateContactTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateContactTaskRequest instance to a JSON string
   */
  static serialize(instance: CreateContactTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateContactTaskRequest instance to a plain object
   */
  static toObject(instance: CreateContactTaskRequest): any {
    return {
      'parentObjectId': instance.parentObjectId,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'description': instance.description,
      'name': instance.name,
      'assignedUserId': instance.assignedUserId,
      'dueDate': instance.dueDate,
      'priority': instance.priority,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'entityId': instance.entityId,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of CreateContactTaskRequest instances to a JSON string
   */
  static serializeArray(instances: CreateContactTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
